import React from "react";
import TextField from "@material-ui/core/TextField";
import BsPanelHeaderFilterControl from "components/panel/header/BsPanelHeaderFilterControl";
import Col from "components/layout/Col";
import Row from "components/layout/Row";
import {useTranslation} from "react-i18next";

const LocationBicyclesFilters = (props) => {
    const {t} = useTranslation();
    const labelRef = React.createRef();
    const addressRef = React.createRef();

    return (
        <Row>
            <Col size="6">
                <BsPanelHeaderFilterControl>
                    <TextField label={t('bicycles.number_filter')}
                               ref={labelRef}
                               type="number"
                               onChange={props.onHandleChange.bind(this, "number")}
                               value={props.fields["number"]}
                               className="form-control"/>
                </BsPanelHeaderFilterControl>
            </Col>
        </Row>
    )
}

export default LocationBicyclesFilters;
